import { makeStyles } from "@material-ui/core";

import { fontFamily } from "../../../../app/theme";

export const useQuoteInfoStyles = makeStyles((theme) => ({
  box: {
    width: "472px",
    height: "430px",
    borderRadius: "6px",
    position: "relative",
    filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.07)) drop-shadow(0px 15px 15px rgba(50, 50, 93, 0.1))",
    [theme.breakpoints.down("md")]: {
      margin: "0 auto",
      height: "430px",
      width: "430px"
    },
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
      height: "350px",
      width: "220px",
      filter: "none"
    }
  },
  boxClipPath: {
    height: "100%",
    filter: "url(#round)"
  },
  boxContent: {
    height: "100%",
    background: "#fff",
    clipPath: "polygon(calc(100% - 60px) 0, calc(100% - 60px) 60px, 100% 60px, 100% 100%, 0 100%, 0 0)",
    [theme.breakpoints.down("sm")]: {
      clipPath: "none"
    }
  },
  btnBookNow: {
    "width": "100%",
    "borderRadius": "28px",
    "boxShadow": "none",
    "height": "55px",
    "fontSize": "18px",
    "fontFamily": fontFamily.Axiforma,
    "fontWeight": 500,
    "& .MuiButton-label": { marginTop: "5px" },
    "&:hover": { boxShadow: "none" },
    [theme.breakpoints.down("sm")]: {
      height: "40px",
      fontSize: "16px"
    }
  }
}));
